var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      label: _vm.label,
      fancy: _vm.fancy,
      items: _vm.filteredItems,
      open: "",
      icon: _vm.icon,
      disabled: _vm.disabled,
      "has-error": _vm.hasError,
    },
    on: {
      "item-click": function ($event) {
        return _vm.onItemClick($event)
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      "icon-click": function ($event) {
        return _vm.removeClicked()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("div", [
              _c("div", { staticClass: "code" }, [
                _vm._v(" " + _vm._s(scope.item.Code) + " "),
              ]),
              _c("div", { staticClass: "name" }, [
                _vm._v(" " + _vm._s(scope.item.Description) + " "),
              ]),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }